var _g, _path, _path2, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyOtpImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_b_18701_13852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "url(#paint0_linear_18701_13852)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5723 1.41406C23.3494 1.41406 18.3047 6.45874 18.3047 12.6817V70.4281C18.3047 76.6511 23.3494 81.6958 29.5723 81.6958H70.4174C76.6403 81.6958 81.685 76.6511 81.685 70.4282V15.4986H83.0934C86.9827 15.4986 90.1357 12.3456 90.1357 8.45632C90.1357 4.56699 86.9827 1.41406 83.0934 1.41406H81.685H29.5723Z",
    fill: "url(#paint1_linear_18701_13852)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M90.1382 8.25597C90.1381 8.84479 90.0482 10.1348 89.8714 10.6974C89.7546 11.0584 89.604 11.408 89.4218 11.7418C89.1458 12.2347 88.8007 12.6871 88.3967 13.0857C86.833 14.6283 83.8002 15.5006 81.6875 15.5006C82.0146 13.6763 80.2791 -2.10435 86.7443 2.45668C87.19 2.69705 87.5895 3.01293 87.9485 3.36632C88.7783 4.18319 89.434 4.93662 89.8714 6.51905L89.9515 6.7998C90.0011 6.98728 90.0405 7.17721 90.0696 7.3688C90.1157 7.66234 90.1387 7.95895 90.1382 8.25597Z",
    fill: "url(#paint2_linear_18701_13852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2476 52.5406C57.265 52.5804 57.2817 52.6203 57.2976 52.6602L57.2976 52.6602C57.6411 53.6905 57.9846 54.7209 57.8128 55.7513C57.8128 60.0446 54.2065 63.6509 49.9133 63.6509H49.3981C48.0242 63.6509 46.6504 63.1357 45.4483 62.2771C44.9331 61.9336 44.4179 61.4184 43.9027 60.9032L43.9027 60.9032C42.7006 59.5294 42.0137 57.8121 42.0137 55.923C42.0137 53.5188 43.0441 51.2863 44.7614 49.9125C44.9151 49.81 45.0536 49.7075 45.1859 49.6095C45.4968 49.3793 45.7738 49.1743 46.1352 49.0538C46.5512 48.7765 47.0791 48.6111 47.5382 48.4673C47.6477 48.433 47.7533 48.4 47.8525 48.3669C48.5394 48.1952 49.3981 48.0234 50.085 48.0234C52.1457 48.0234 54.2065 48.8821 55.5803 50.2559C55.6051 50.2807 55.6299 50.3057 55.6547 50.3309L55.5811 50.429L53.0052 53.3484L51.9748 54.3788L50.9444 55.4092L50.0857 56.4396L48.5402 54.7223C48.025 54.2071 47.1663 54.0354 46.4794 54.5506C45.9642 55.0658 45.7925 55.9244 46.3077 56.6113L48.8836 59.5307C49.2271 59.8742 49.5705 60.0459 49.914 60.0459C50.2575 60.0459 50.7727 59.8742 50.9444 59.5307L51.803 58.6721L53.1769 57.1265L54.2073 55.9244L57.1267 52.6615L57.2476 52.5406Z",
    fill: "#6FDF97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.184 15.452C33.64 15.452 34.858 15.9 35.796 16.81C36.678 17.664 37.252 18.896 37.252 20.338C37.252 21.584 36.804 22.858 35.796 23.838C34.928 24.678 33.752 25.21 32.184 25.21C30.434 25.21 29.244 24.51 28.544 23.838C27.648 22.998 27.088 21.738 27.088 20.366C27.088 19.022 27.69 17.664 28.53 16.824C29.16 16.194 30.322 15.452 32.184 15.452ZM32.17 17.44C31.358 17.44 30.63 17.734 30.126 18.238C29.72 18.63 29.3 19.316 29.3 20.352C29.3 21.206 29.58 21.892 30.154 22.452C30.756 23.026 31.428 23.222 32.156 23.222C33.108 23.222 33.78 22.872 34.228 22.424C34.592 22.074 35.04 21.416 35.04 20.338C35.04 19.372 34.648 18.658 34.228 18.238C33.766 17.79 33.024 17.44 32.17 17.44ZM43.8885 17.482H41.8585V25H39.7025V17.482H37.6725V15.662H43.8885V17.482ZM45.022 15.662H48.312C49.124 15.662 50.02 15.774 50.762 16.432C51.56 17.132 51.672 18.056 51.672 18.7C51.672 19.876 51.224 20.534 50.874 20.898C50.132 21.654 49.152 21.724 48.494 21.724H47.178V25H45.022V15.662ZM47.178 17.426V19.96H47.948C48.242 19.96 48.76 19.946 49.11 19.61C49.306 19.414 49.46 19.092 49.46 18.686C49.46 18.294 49.32 17.972 49.11 17.776C48.788 17.468 48.326 17.426 47.906 17.426H47.178Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30.5747,
    y1: 34.1328,
    x2: 34.5747,
    y2: 34.1328,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.5747,
    y1: 34.1328,
    x2: 44.5747,
    y2: 34.1328,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.5747,
    y1: 34.1328,
    x2: 54.5747,
    y2: 34.1328,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5747,
    y1: 34.1328,
    x2: 64.5747,
    y2: 34.1328,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_18701_13852",
    x: -25.7179,
    y: -25.7179,
    width: 151.436,
    height: 151.436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.859
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18701_13852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18701_13852",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18701_13852",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3C49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3C49",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18701_13852",
    x1: 50.9553,
    y1: 1.1627,
    x2: 48.0747,
    y2: 71.7678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F687D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F687D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18701_13852",
    x1: 86.7238,
    y1: 2.19096,
    x2: 86.0171,
    y2: 13.8358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202021",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyOtpImage);
export default __webpack_public_path__ + "static/media/verifyOtpImage.11f01275b8548c80c65833e432c1ee93.svg";
export { ForwardRef as ReactComponent };